angular.module('mercury.modules.error.permission', []);
